import { assert } from '@sindresorhus/is';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { AlignmentContext } from './AlignmentContext';

import type { AlignmentStore } from './alignment-store';

export const useAlignmentStore = <T>(selector: (state: AlignmentStore) => T): T => {
    const alignmentContext = useContext(AlignmentContext);

    assert.plainObject(alignmentContext);

    return useStore(alignmentContext, selector);
};
